import Creator1 from "@/assets/svg/creator-shield/creators/1.svg";
import Creator2 from "@/assets/svg/creator-shield/creators/2.svg";
import Creator3 from "@/assets/svg/creator-shield/creators/3.svg";
import Creator4 from "@/assets/svg/creator-shield/creators/4.svg";
import Creator5 from "@/assets/svg/creator-shield/creators/5.svg";
import Creator6 from "@/assets/svg/creator-shield/creators/6.svg";
import { CSSecondaryBtn } from "@/components/design-system/creatorshield/CSButton";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function HeroSection() {
  const creatorCards = [
    {
      image: Creator1,
      type: "Beauty creator",
      earnings: "$503.72",
      claims: "1000+",
      rotation: 5.579,
      imageRotation: -5,
      imageSize: "!w-[500px] !h-full",
    },
    {
      image: Creator2,
      type: "Cleaning creator",
      earnings: "$3,483.92",
      claims: "100+",
      rotation: 354.382,
      imageRotation: 7,
      imageSize: "!w-[500px] !h-full",
    },
    {
      image: Creator3,
      type: "Beauty creator",
      earnings: "$4,261.85",
      claims: "500+",
      rotation: 11.328,
      imageRotation: -10,
      imageSize: "!w-[500px] !h-full",
    },
    {
      image: Creator4,
      type: "Hair stylist creator",
      earnings: "$336.43",
      claims: "75+",
      rotation: 11.328,
      imageRotation: -10,
      imageSize: "!w-[500px] !h-full",
    },
    {
      image: Creator5,
      type: "D.I.Y creator",
      earnings: "$2,592.34",
      claims: "50+",
      rotation: 354.382,
      imageRotation: 10,
      imageSize: "!w-[500px] !h-full",
    },
    {
      image: Creator6,
      type: "ASMR creator",
      earnings: "$3,483.92",
      claims: "4,500+",
      rotation: 11.328,
      imageRotation: -10,
      imageSize: "!w-[500px] !h-full",
    },
  ];

  return (
    <div className="bg-[#FF6B35] py-20 relative overflow-hidden">
      <div className="4xl:max-w-[100rem] 4xl:mx-auto">
        <div className="text-center space-y-6 mb-16 px-6 lg:px-0">
          <h2 className="text-5xl md:text-6xl lg:text-7xl font-semibold text-white leading-tight">
            Creatorshield <span className="text-[#ff8c5f]">is that simple</span>
          </h2>
          <p className="text-base md:text-lg text-white max-w-3xl mx-auto font-normal">
            Not only is CreatorShield simple. It is free, safe, and takes less
            than 1-minute to get started
          </p>
        </div>

        {/* Creator Cards - Horizontal Scroll Layout */}
        <div className="relative mb-12 overflow-hidden">
          <div className="flex gap-16 overflow-x-auto py-10 scrollbar-hide px-8 lg:px-6 items-center">
            {creatorCards.map((card, index) => (
              <div
                key={index}
                className="bg-white rounded-[10px] overflow-hidden shadow-lg flex-shrink-0 w-[330px] h-[430px] relative"
                style={{
                  transform: `rotate(${card.rotation}deg)`,
                }}
              >
                {/* Image */}
                <div className="w-full h-[273px] relative overflow-hidden ">
                  <img
                    src={card.image}
                    alt={card.type}
                    className={`w-full h-full object-cover ${card.imageSize}`}
                    style={{
                      transform: `scale(1.2) rotate(${card.imageRotation || 0}deg)`,
                    }}
                  />
                </div>

                {/* Card Info */}
                <div className="bg-[#f6f6f6] h-[157px] p-5 flex flex-col justify-between">
                  <p className="text-base font-normal text-black">
                    {card.type}
                  </p>
                  <p className="text-4xl font-semibold text-[#FF6B35] leading-none">
                    {card.earnings}
                  </p>
                  <p className="text-base font-normal text-black">
                    Stolen re-upload claims: {card.claims}
                  </p>
                </div>
              </div>
            ))}

            {/* See More Results Button Card */}
            <Link to="/case-study">
              <div className="flex-shrink-0 flex items-center justify-center w-[220px] h-[220px] bg-white rounded-full">
                <div className="w-full h-full rounded-full bg-white/20 border-2 border-white/30 flex flex-col items-center justify-center gap-2 cursor-pointer hover:bg-white/30 transition-colors">
                  <p className="text-xl font-semibold text-[#FF6B35]">
                    See more results
                  </p>
                  <ArrowRight size={24} className="text-[#FF6B35]" />
                </div>
              </div>
            </Link>
          </div>
        </div>

        {/* CTA Button */}
        <div className="flex justify-center">
          <Link to="/case-study">
            <CSSecondaryBtn
              name="See more results"
              className="!w-40"
            />
          </Link>
        </div>
      </div>
    </div>
  );
}
